import React from "react";

function Table({ data, onDelete }) {
  return (
    <table style={tableStyle}>
      <thead>
        <tr style={headerRow}>
          <th style={thStyle}>Book Title</th>
          <th style={thStyle}>Author</th>
          <th style={thStyle}>Genre</th>
          <th style={thStyle}>Delete</th> {}
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr
            key={item.id}
            style={index % 2 === 0 ? rowEven : rowOdd}
          >
            <td style={tdStyle}>{item.title}</td>
            <td style={tdStyle}>{item.author}</td>
            <td style={tdStyle}>{item.genre}</td>
            <td style={tdStyle}>
              <button
                style={deleteButtonStyle}
                onClick={() => onDelete(item.id)}
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  backgroundColor: "#ffffff",
  boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
  borderRadius: "15px",
  overflow: "hidden",
};

const headerRow = {
  backgroundColor: "#cdb4db",
  border: "1px solid #000000" 
};

const thStyle = {
  color: "#4a4a4a",
  padding: "14px",
  fontWeight: "600",
};

const tdStyle = {
  padding: "12px",
  borderBottom: "1px solid #f1e4f3",
  color: "#555",
};

const rowEven = {
  backgroundColor: "#f8edeb", 
};

const rowOdd = {
  backgroundColor: "#fae1dd",
};

const deleteButtonStyle = {
  backgroundColor: "#ff8fab", 
  color: "white",
  padding: "6px 12px",
  border: "none",
  borderRadius: "15px",
  cursor: "pointer",
};

export default Table;